export function PageHeader({ title, subtitle, actions, testid }) {
  return (
    <div data-testid={testid} className="h-16 px-6 lg:px-8 border-b border-slate-200 bg-white flex items-center justify-between">
      <div>
        <h1 className="font-heading text-lg font-semibold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </div>
  );
}

export function StatusBadge({ status, label }) {
  const map = {
    completed: "bg-emerald-100 text-emerald-700 border-emerald-200",
    sent: "bg-emerald-100 text-emerald-700 border-emerald-200",
    in_progress: "bg-blue-100 text-blue-700 border-blue-200",
    approved: "bg-blue-100 text-blue-700 border-blue-200",
    not_started: "bg-slate-100 text-slate-700 border-slate-200",
    on_hold: "bg-amber-100 text-amber-800 border-amber-200",
    pending_approval: "bg-amber-100 text-amber-800 border-amber-200",
    cancelled: "bg-slate-100 text-slate-500 border-slate-200",
    blocked: "bg-slate-200 text-slate-600 border-slate-300",
    failed: "bg-rose-100 text-rose-700 border-rose-200",
    overdue: "bg-rose-100 text-rose-700 border-rose-200",
    due_soon: "bg-amber-100 text-amber-800 border-amber-200",
    on_track: "bg-emerald-100 text-emerald-700 border-emerald-200",
    active: "bg-emerald-100 text-emerald-700 border-emerald-200",
    prospect: "bg-blue-100 text-blue-700 border-blue-200",
    archived: "bg-slate-100 text-slate-500 border-slate-200",
    paused: "bg-amber-100 text-amber-800 border-amber-200",
    partial: "bg-amber-100 text-amber-800 border-amber-200",
    unpaid: "bg-amber-100 text-amber-800 border-amber-200",
    draft: "bg-slate-100 text-slate-700 border-slate-200",
    paid: "bg-emerald-100 text-emerald-700 border-emerald-200",
    void: "bg-slate-100 text-slate-500 border-slate-200",
  };
  const cls = map[status] || "bg-slate-100 text-slate-700 border-slate-200";
  const text = (label || status || "—").toString().replace(/_/g, " ");
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-medium ${cls}`}>
      {text}
    </span>
  );
}
